import { render, staticRenderFns } from "./_iab-text-management.vue?vue&type=template&id=4e8d2b70"
import script from "./_iab-text-management.vue?vue&type=script&lang=js"
export * from "./_iab-text-management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports